import axios from "axios";


export default axios.create({
    baseURL: process.env.REACT_APP_API_TTE,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    },
});
